<mat-sidenav-container class="sidenav-container" [hasBackdrop]=" ">
    <mat-sidenav #sidenav mode="side" disableClose position="end" [opened]="  ">

    </mat-sidenav>

    <mat-sidenav-content>
        <div class="container fixed" id="infinite-scroller">
            <div class="doc-form mat-elevation-z2" @fadeInToLeft>
                <header class="card">
                    <button mat-icon-button color="warn" class="document-back">
                        <mat-icon aria-label="back">keyboard_arrow_left</mat-icon>
                    </button>
                    <div class="group">
                        <h3 class="title">Engin</h3>
                        <h4 class="subtitle">Engin</h4>
                    </div>
                    <div class="spacer"></div>
                </header>
                <header class="card new-doc">
                    <h3 class="title">{{'new_doc.title' | translate}}</h3>
                    <div class="spacer"></div>
                </header>

            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>